import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { connect, mapStateToProps, mapDispatchToProps } from '../../helpers/Common'
import { LangResetData, LangSampleDataBar1, LangSampleDataBar2, LangSampleDataBar3 } from '../../constant/languange'

const SampleDataInfoBar = ({ redux }) => {
  if (!redux.isTemporary) return <></>

  // menu Kosongkan Data tidak tersedia untuk role_id 4
  const canReset = redux.profile.role_id !== 4

  return (
    <div className='sample-data-info-bar container-fluid py-2 d-flex align-items-start align-items-md-center text-dark' style={{ background: '#FFE8BA', fontSize: '14px', lineHeight: '20px' }}>
      <FontAwesomeIcon className='mr-2 mt-1 mt-md-0' icon={faInfoCircle} />
      <span>
        <strong>{LangSampleDataBar1}</strong>
        {canReset && (
          <span className='d-none d-md-inline'>
            {' '}{LangSampleDataBar2}{' '}
            <Link to='/reset' className='font-weight-bold' style={{ textDecoration: 'underline' }}>{LangResetData}</Link>
            {LangSampleDataBar3}
          </span>
        )}
        {canReset && (
          <span className='d-md-none'>
            {' '}<Link to='/reset' className='font-weight-bold' style={{ textDecoration: 'underline' }}>{LangResetData}</Link>
          </span>
        )}
      </span>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(SampleDataInfoBar)
